export const genres = [
  "Draama",
  "Komöödiafilm",
  "Muusika/tantsu",
  "Melodraama",
  "Suhtedraama",
  "Koguperefilm",
  "Sõjafilm",
  "Noortefilm",
  "Ulmefilm",
  "Põnevusfilm",
  "Teekonnafilm",
  "Muinasjuttfilm",
  "Erootikafim",
  "Eluloofilm",
  "Üleloomulik film",
  "Kriminaalfilm",
  "Eepiline/ajalooline film",
  "Trikkfilm",
  "Armastusfilm",
  "Fantaasiafilm",
  "Seiklusfilm",
  "Õudusfilm",
  "Spordifilm",
  "Detektiivfilm"
];

export const roles = [
  "Monteerija",
  "Režissöör",
  "Valgusmeister",
  "Actor (Episodic)",
  "Värvimääraja",
  "Operaatori I assistent",
  "Operaator",
  "Stsenarist",
  "Operaatori assistent",
  "Valgustaja",
  "Fotograaf",
  "Actor (Lead)",
  "Dekoratsioonide valmistaja",
  "Toimetaja",
  "Kunstnik",
  "Kunstniku assistent",
  "Helioperaatori assistent",
  "Helirežissöör",
  "Helirežissöör platsil",
  "Actor (Supporting)",
  "Helioperaator",
  "Kirjandusliku alusteose autor",
  "Režissööri assistent",
  "Tõlkija",
  "Operaatori II assistent",
  "Produtsent",
  "Dekoraator",
  "Eriefektid",
  "Grimeerija",
  "Fookusevedaja",
  "Kostüümikunstnik",
  "Helilooja",
  "Direktor",
  "Kostümeerija",
  "Visuaalsed efektid",
  "Animaator",
  "Helikujundaja",
  "Heli järeltöötlus",
  "Heli kokkusalvestaja",
  "Tegevprodutsent",
  "Režissööri I assistent",
  "Klapp",
  "Rekvisiitor",
  "Konsultant",
  "Poomioperaator",
  "Tootmisjuht",
  "Teksti lugeja",
  "Idee autor",
  "Stedicam operaator",
  "Lisavõtete operaator",
  "Kostüümikunstniku assistent",
  "Režissööri II assistent",
  "Jumestuskunstnik",
  "Juhendaja",
  "Kaasprodutsent",
  "Kunstnik-grimeerija",
  "Dialoogi autor",
  "Helimonteerija",
  "Elektrik",
  "Kärumees",
  "II operaator",
  "Näitlejate valija",
  "Administraator",
  "Produtsendi assistent",
  "Võttekohtade koordinaator",
  "Stsenaariumi toimetaja",
  "Monteerija assistent",
  "Tootmiskoordinaator",
  "Tootmisassistent",
  "Sünkroontaustad",
  "Järjepidaja",
  "Graafiline disainer",
  "DIT",
  "Ehitaja",
  "Pilditöötleja",
  "Võttekohtade koordinaatori assistent",
  "B-kaamera operaator",
  "Drooni operaator",
  "Kirjeldustõlk",
  "Kirjeldustõlke lugeja",
  "Heliinsener",
  "Kaameratehnik",
  "Digipildi töötleja",
  "Toitlustaja (kokk)",
  "Tehnik",
  "Kaskadöör",
  "Teksti autor",
  "Kombineeritud võtete operaator",
  "Vanemadministraator",
  "Värvikunstnik",
  "Koreograaf",
  "II režissöör",
  "Spetsefektid",
  "Kujundaja",
  "Arvutigraafik",
  "Režissööri abi",
  "Platsi administraator",
  "Tootmisjuhi abi",
  "Pürotehnik",
  "Kaameramehaanik",
  "Raamatupidaja",
  "Direktori asetäitja",
  "Puusepp",
  "Dirigent",
  "Abitööline",
  "Kunstnik-dekoraator",
  "Laadija",
  "Kombineeritud võtete kunstnik",
  "Digitaalne järeltöötlus",
  "Negatiivimonteerija",
  "Monteerija abi",
  "Autojuht",
  "Avalikud suhted",
  "Stsenaariumi konsultant",
  "II monteerija",
  "Kunstnik-multiplikaator",
  "Rekvisiitide valmistaja",
  "On-line montaaž",
  "Komposiitor",
  "Muusikaline kujundaja",
  "Režissöör (II)",
  "Videoefektid",
  "Diktor",
  "Nukutegija",
  "Plakatikunstnik",
  "Juuksur",
  "Butafoor",
  "Grimeerija assistent",
  "Ehitusmeister",
  "Järeltöötluse produtsent",
  "Valgusmääraja",
  "Videograafika",
  "3D animaator",
  "Visuaalkunstnik",
  "Kärumehe assistent",
  "Dekoratsioonide- ja rekvisiitide valmistaja",
  "Operaator-lavastaja",
  "3D eriefektid",
  "Kolorist",
  "Piltstsenaariumi joonistaja",
  "Autor",
  "Hääl animafilmis",
  "Faasi-ja ümberjoonistaja",
  "Nukkude- ja dekoratsioonide valmistaja",
  "Turundusjuht",
  "Värvija",
  "Klapilööja",
  "Digitöötluse spetsialist",
  "Digitöötluse konsultant",
  "Heli järeltöötluse assistent",
  "Peakunstnik",
  "Foonikunstnik",
  "Dubleerija",
  "3D graafika",
  "Peaprodutsent"
]

export const subTypes = [
  "Lühimängufilm",
  "Harjutusfilm (lavastuslik)",
  "Harjutusfilm (dokumentaalne)",
  "Dokumentaalfilm",
  "Muusikavideo",
  "Animafilm",
  "Tehtud välisülikoolis",
  "Probleemfilm",
  "Olukirjeldusfilm",
  "Portreefilm",
  "Reklaam/Promofilm",
  "Täispikk mängufilm",
  "Telesaade"
]


export const colorsValues = {
  "Draama": "#19363a",
  "Komöödiafilm": "#1e7cbf",
  "Muusika/tantsu": "#fec958",
  "Melodraama": "#173a51",
  "Suhtedraama": "#192b4b",
  "Koguperefilm": "#002d4b",
  "Sõjafilm": "#15cda1",
  "Noortefilm": "#0b2852",
  "Ulmefilm": "#ffc261",
  "Põnevusfilm": "#00cea0",
  "Teekonnafilm": "#13d191",
  "Muinasjuttfilm": "#00d5b4",
  "Erootikafim": "#0e87c5",
  "Eluloofilm": "#e14d61",
  "Üleloomulik film": "#ef3e80",
  "Kriminaalfilm": "#0088b3",
  "Eepiline/ajalooline film": "#1f9bac",
  "Trikkfilm": "#fed35c",
  "Armastusfilm": "#ffdb66",
  "Fantaasiafilm": "#003f41",
  "Seiklusfilm": "#fe545d",
  "Õudusfilm": "#07e190",
  "Spordifilm": "#df4462",
  "Detektiivfilm": "#ea376b",
  "Default_Movie": "#f1ca57",
  "Default_Person": "#00d19c"
}

export const years = [
  "1955",
  "1956",
  "1962",
  "1963",
  "1966",
  "1971",
  "1973",
  "1974",
  "1975",
  "1976",
  "1978",
  "1979",
  "1987",
  "1988",
  "1989",
  "1990",
  "1991",
  "1993",
  "1994",
  "1995",
  "1996",
  "1997",
  "1998",
  "1999",
  "2000",
  "2001",
  "2002",
  "2003",
  "2004",
  "2005",
  "2006",
  "2007",
  "2008",
  "2009",
  "2010",
  "2011",
  "2012",
  "2013",
  "2014",
  "2015",
  "2016",
  "2017",
  "2018",
  "2019",
  "2020",
  "2021",
  "2022",
  "2023",
  "2024"
]

export const findNodeById = (nodes, id) => {
  return nodes.find(node => node.id === id ||  node.id === parseInt(id)) || null;
}

export async function loadMovieDataAlt(manfredId, setGenreList, setRoleList) {
  try {

    const response = await fetch('https://dti.tlu.ee/errlinked/wire/api/studentmovies'); // Path relative to public folder
    const data = await response.json();
    /*{
      console.log(data)
      data.nodes = processData(data.nodes)
      console.log(data)
    }*/
    return await data

  } catch (error) {
    console.error('Error loading movie data:', error);
    return null;
  }
}

const applyGraphFilters = (items, filters) => {
  return items.filter((item) =>
    Object.entries(filters).every(([key, value]) => {
      if (value === "" || value === null || value === undefined) return true;

      if (Array.isArray(value) && key === "priceRange") {
        return item.price >= value[0] && item.price <= value[1];
      }

      if (typeof value === "boolean") return item[key] === value;
      if (typeof value === "string") return item[key]?.toLowerCase().includes(value.toLowerCase());

      return item[key] === value;
    })
  );
};

export const processData = (data) => {
  return data.map((person) => {
    if (!person.movies) return person;
    // Extract unique subtypes and years from movies
    const neighborSubtypes = [...new Set(person.movies.map((movie) => movie.subtype).filter(Boolean))];
    const neighborYears = [...new Set(person.movies.map((movie) => movie.year).filter(Boolean))];

    // Return the updated object with new properties
    return { ...person, neighborSubtypes, neighborYears };
  });
};

export function getEfisImageUrl(personId, filename) {
  const baseUrl = 'https://www.efis.ee/_next/image';
  const imagePath = `https://cdn.efis.ee/is/EfisPeople/${personId}/${filename}`;
  const params = new URLSearchParams({
    url: imagePath,
    w: 1920,
    q: 75
  });
  return `${baseUrl}?${params.toString()}`;
}

export function getEfisMovieImageUrl(filename, galleryFileId, width = 1200, quality = 75) {
  const encodedUrl = encodeURIComponent(
    `https://cdn.efis.ee/is/EfisFilms/Thumbnails/${galleryFileId}/${filename}`
  );
  return `https://www.efis.ee/_next/image?url=${encodedUrl}&w=${width}&q=${quality}`;
}

